import { v4 as uuidv4 } from 'uuid';

type DataMaskAttributeTypes =
  | {
      'data-clarity-mask': string;
    }
  | {};

export const getDataMaskAttribute = (
  enableDataMask: boolean
): DataMaskAttributeTypes => {
  if (enableDataMask) {
    return {
      'data-clarity-mask': 'True'
    };
  }
  return {};
};

export const getUniversalUniqueId = (): string => {
  return uuidv4();
};

export const getFrontEndFormPathId = () => {
  const pathname = window.location.pathname;

  const pathArray = pathname.split('/');

  const pathArrayLength = pathArray.length;
  const lastIndex = pathArrayLength - 1;
  const lastValue = pathArray[lastIndex];

  if (lastValue === '') {
    return pathArray[pathArrayLength - 2];
  }
  return pathArray[lastIndex];
};

export function getQueryParam(url: string, param: string) {
  // NOTE: Expects a raw URL
  param = param.replace(/[[]/, '[').replace(/[]]/, ']'); // eslint-disable-line
  const urlRegexExpression = '[?&]' + param + '=([^&#]*)';
  const regex = new RegExp(urlRegexExpression);
  const results: Array<any> | null = regex.exec(url);
  if (
    results === null ||
    (results && typeof results[1] !== 'string' && results[1].length)
  ) {
    return '';
  } else {
    //NOTE: We are sending the exact param, without replacing any character, to avoid confusion in UTM values
    return decodeURIComponent(results[1]);
  }
}

type GetRandomFromArrayOrRangeParams<T> =
  | { array: T[]; min?: undefined; max?: undefined }
  | { array?: undefined; min: number; max: number };

export const getRandomFromArrayOrRange = <T>({
  array,
  min,
  max
}: GetRandomFromArrayOrRangeParams<T>): T | number => {
  if (array) {
    return array[Math.floor(Math.random() * array.length)];
  }
  if (typeof min === 'number' && typeof max === 'number') {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  throw new Error(
    'Invalid arguments: Provide either an array or both min and max numbers.'
  );
};
